module.exports = __webpack_public_path__ + "img/notification-error.a914ebc1.svg";